import EventEmitter from '../events'

class SessionStorage extends EventEmitter {
  // static instance:any
  // static getInstance () {
  //   if (!SessionStorage.instance) {
  //     SessionStorage.instance = new SessionStorage()
  //   }
  //   return SessionStorage.instance
  // }

  getItem (key: string) {
    return window.sessionStorage.getItem(key);
  }

  setItem (key: string, value: any) {
    const oldV = this.getItem(key)
    window.sessionStorage.setItem(key, value);
    this.emit(key, value, oldV)
  }

  clear () {
    Object.keys(window.sessionStorage).forEach((key:string) => {
      const oldV = this.getItem(key)
      this.emit(key, null, oldV)
    })
    window.sessionStorage.clear();
  }

  removeItem (key: string) {
    const oldV = this.getItem(key)
    if (oldV) {
      this.emit(key, null, oldV)
    }
    window.sessionStorage.removeItem(key);
  }

  key (index: number) {
    return window.sessionStorage.key(index);
  }
};
export default new SessionStorage()
// export default SessionStorage.instance()